import VShowcase from "./VShowcase"
import VShowcaseShop from "./VShowcaseShop"
import VShowcaseShopItem from "./VShowcaseShopItem"


export default VShowcase;

VShowcase.Shop = VShowcaseShop;
VShowcaseShop.Item = VShowcaseShopItem;
